import { intl } from '@/intl'
import { durationUtils } from '@/server-data'

import { NullValue } from './NullValue'

interface Props {
  isNull?: (value: number) => boolean
  children: number
}

function defaultIsNull(value: number) {
  return value === 0
}

export function DurationValue(props: Props) {
  const { children, isNull = defaultIsNull } = props

  return isNull(children) ? (
    <NullValue />
  ) : (
    durationUtils.formatSeconds(intl.translate)(children, 'SHORT')
  )
}
